import { render, staticRenderFns } from "./SettlementCheckMeBack.vue?vue&type=template&id=270ef008&"
import script from "./SettlementCheckMeBack.vue?vue&type=script&lang=js&"
export * from "./SettlementCheckMeBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports